<div class="ui-g-12 no-horizontal-padding text-left list-item-container"
	[ngClass]="{
		'has-override': (ruleDefinition?.overridable === true && overrideAllowed === true)
	}">

	<div class="ui-g-12 no-horizontal-padding description-container"
		*ngIf="ruleDefinition?.description != null">
		<markdown
			[data]="ruleDefinition.description">
		</markdown>
	</div>
	<div class="top-padding-element"
		*ngIf="ruleDefinition?.description == null">
	</div>

	<output *ngIf="loadingTables === true"
		class="text-center ui-g-12 no-horizontal-padding"
		aria-live="polite">
		<span class="fa fa-fw fa-spin fa-spinner theme-color double-font-size"
			aria-hidden="true">
		</span>
		<span class="visually-hidden">
			Loading rule details
		</span>
	</output>

	<div *ngIf="hasArrayItemLabel"
		class="ui-g-12 no-horizontal-padding array-item-context">
		<i class="fa fa-fw fa-list-ul array-item-icon"
			aria-hidden="true"></i>
		<span class="array-item-label">
			{{arrayItemLabel}}
		</span>
	</div>

	<div *ngIf="loadingTables === false	&& rulePresentationDefinitions.length > 0"
		class="ui-g-12 table-container quick-access-section no-horizontal-padding">
		<div class="quick-access-header panel-sub-title">
			<span class="table-title">
				Quick Access
			</span>
		</div>
		<div class="quick-access-list">
			<ng-container *ngFor="let rulePresentationDefinition of rulePresentationDefinitions">
				<button *ngIf="rulePresentationDefinition.dataKey !== 'form'"
					type="button"
					class="quick-access-row theme-hover"
					(click)="navigateToControl(rulePresentationDefinition)"
					[pTooltip]="getFormattedDataKey(rulePresentationDefinition)"
					[escape]="false"
					tooltipPosition="left"
					[attr.aria-label]="getQuickAccessAriaLabel(rulePresentationDefinition)">
					<span class="quick-access-path ellipsis-text">
						{{getFormattedDataKeyLabel(rulePresentationDefinition)}}
					</span>
					<i class="fa fa-fw fa-crosshairs quick-access-icon theme-color"
						aria-hidden="true">
					</i>
				</button>
			</ng-container>
		</div>
	</div>

	<div *ngIf="loadingTables === false && ruleViolationWorkflowActions.length > 0"
		class="ui-g-12 table-container workflow-restrictions-section no-horizontal-padding">
		<p-accordion>
			<p-accordionTab
				[header]="'Workflow Restrictions'"
				[selected]="false"
				[transitionOptions]="'0ms'">
				<p-table [value]="ruleViolationWorkflowActions"
					responsiveLayout="scroll">
					<ng-template pTemplate="header">
						<tr>
							<th scope="col"
								class="text-left">
								Name
							</th>
							<th scope="col"
								class="text-center"
								[style]="{'width':'70px'}">
								Blocked
							</th>
							<th scope="col"
								class="text-center"
								[style]="{'width':'85px'}">
								Overridden
							</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-ruleViolationWorkflowAction>
						<tr>
							<td class="text-left name-column">
								<div class="ellipsis-text"
								[pTooltip]="getActionDisplayName(ruleViolationWorkflowAction)"
									tooltipPosition="top">
									{{getActionDisplayName(ruleViolationWorkflowAction)}}
								</div>
							</td>
							<td class="text-center"
								[style]="{'width':'70px'}">
								<span>
									<ng-template [ngIf]="ruleViolationWorkflowAction.blocked === true"
										[ngIfElse]="WarningDisplay">
										<app-common-icon-tooltip #BlockedTooltip
											[content]="blockedTooltipMessage"
											position="left"
											iconClass="fa fa-fw fa-flag column-icon">
										</app-common-icon-tooltip>
									</ng-template>
									<ng-template #WarningDisplay>
										<app-common-icon-tooltip #WarningTooltip
											[content]="warningTooltipMessage"
											position="left"
											iconClass="fa fa-fw fa-flag-checkered column-icon">
										</app-common-icon-tooltip>
									</ng-template>
								</span>
							</td>
							<td class="text-center"
								[style]="{'width':'85px'}">
								<span *ngIf="ruleViolationWorkflowAction.overridden === true">
									<i class="fa fa-fw fa-check column-icon"
										aria-hidden="true">
									</i>
									<span class="visually-hidden">
										Overridden
									</span>
								</span>
							</td>
						</tr>
					</ng-template>
				</p-table>
			</p-accordionTab>
		</p-accordion>
	</div>

	<div *ngIf="ruleDefinition?.overridable === true && overrideAllowed === true"
		class="ui-g-12 no-horizontal-padding text-right override-container">
		<p-button class="override-button no-margin-right"
			(click)="displayOverride()">
			Override
		</p-button>
	</div>
</div>